import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Text,
} from '@chakra-ui/react';
import { useState } from 'react';

interface ExpiredLinkCardProps {
  token: string;
  // When omitted, no resend button is shown and the card explains how to get a
  // new link instead (e.g. system-generated links with no recipient to resend to).
  resendLink?: (token: string) => Promise<void>;
  loading?: boolean;
}

export const ExpiredLinkCard = ({
  token,
  resendLink,
  loading = false,
}: ExpiredLinkCardProps) => {
  const [sent, setSent] = useState(false);

  return (
    <Card>
      <CardHeader>
        <Text color="whiteAlpha.600" fontWeight="medium">
          Sorry, this link has expired.
        </Text>
      </CardHeader>
      <CardBody>
        <Text>
          {resendLink
            ? 'Please click the button below to get a new link. It will be sent to the original shared email or phone number.'
            : 'Please contact your broker or the Indigo team to request a new link.'}
        </Text>
      </CardBody>
      {resendLink && (
        <CardFooter justifyContent="flex-end">
          <Button
            isDisabled={sent}
            isLoading={loading}
            size="xs"
            onClick={() => {
              void (async () => {
                try {
                  await resendLink(token);
                  setSent(true);
                } catch (error) {
                  // Leave the button enabled so the user can retry.
                  // eslint-disable-next-line no-console
                  console.error('Failed to resend share link:', error);
                }
              })();
            }}
          >
            {sent ? 'Link Sent' : 'Get New Link'}
          </Button>
        </CardFooter>
      )}
    </Card>
  );
};
